import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15.5 19a.497.497 0 0 1-.239-.061L10 16.07l-5.261 2.869c-.168.092-.373.079-.529-.032s-.235-.301-.203-.49l.958-5.746-3.818-3.818c-.132-.132-.18-.328-.123-.506s.209-.31.394-.341l5.749-.958 2.386-4.772C9.638 2.107 9.811 2 10 2s.363.107.447.276l2.386 4.772 5.749.958c.185.031.337.162.394.341s.01.374-.123.506l-3.818 3.818.958 5.746a.5027.5027 0 0 1-.203.49.5027.5027 0 0 1-.29.093zM10 15c.082 0 .165.02.239.061l4.599 2.508-.831-4.987a.4972.4972 0 0 1 .14-.436l3.313-3.313-5.042-.84a.5004.5004 0 0 1-.365-.27L10 3.617 7.947 7.723a.5029.5029 0 0 1-.365.27l-5.042.84 3.313 3.313a.502.502 0 0 1 .14.436l-.831 4.987 4.599-2.508A.497.497 0 0 1 10 15z',
  ],
  height: 20,
  width: 20,
});
